import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo, FileSelectorViewModel } from "uicomponents";
import  { DirhamPriceManipulationView } from "./dirhamPriceManipulation-view";
import { DollarPriceManipulationViewModel } from "../dollarPriceManipulation/dollarPriceManipulation-viewModel";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";

export class DirhamPriceManipulationViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: DollarPriceManipulationViewModel) {
        super(parentViewModel);
        this._parent = parentViewModel;
        this.dirhamPrice = ObservableArray.create<dirhamPrice>();
        this.fileSelector = new FileSelectorViewModel(this);
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DirhamPriceManipulationView();
    }
    public getTypeId(): string {
        return "VM-E5819A67-0277-44E3-8BFD-D5E771A070A4"
    }

    closePopup(resultCode: string = null) {
    }
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set dirhamPrice(v: ObservableArray<dirhamPrice>) { this._dirhamPrice = v; } public get dirhamPrice(): ObservableArray<dirhamPrice> { return this._dirhamPrice;} private _dirhamPrice: ObservableArray<dirhamPrice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    private _parent: DollarPriceManipulationViewModel;
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            if(filteringInformation.OrderInfo.length == 0)
            {
                let sort = {
                    fieldName:'From',
                    order:'DESC',
                    type:'date'
                };
                filteringInformation.OrderInfo = [sort];
            }
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDirhamPrice',{
                FilteringInformation:filteringInformation
            });
            this.dirhamPrice.update(...result.DirhamPrice.map(q=>{
                let r = new dirhamPrice(this);
                r.id = q.Id;
                r.price = q.Price;
                r.conversionRate = q.ConversionRate;
                r.from = moment.utc(q.From);
                r.until = q.Until==null? null : moment.utc(q.Until);
                r.canInactive = q.Until==null;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestDirhamPriceCreation(){
        let editor = new dirhamPriceEditor(this,new InsertServerUpdater());
        editor.conversionRate = 3.67;
        let resultCode = await this._parent.showPopup(editor, false);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/ExportDirhamPrice',{
            });
            await this.messageBoxConfirmSuccess('فایل خروجی با موفقیت بارگذاری شد.','عملیات موفق');
            downloadFile(result.ExcelFile, `export_dirham_prices.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async import(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/ImportDirhamPrice',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful == true && result.IsValid == true) {    
                await this.messageBoxConfirmSuccess('قیمت های درهم با موفقیت ثبت شد.','عملیات موفق');
                this.refresh();
            } else {
                throw 'داده های ورودی صحیح نیست.';
            }
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning(ex,'خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async dirhamUpdater(dirham:dirhamPrice){
        let editor = new dirhamPriceEditor(this,new UpdateServerUpdater());
        dirham.cloneTo(editor);
        let resultCode = await this._parent.showPopup(editor, false);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async accept(id:any){
        try {
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/DirhamPriceInvalidator',{
                Id:id
            });
            await this.messageBoxConfirmSuccess('قیمت درهم غیر فعال شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
}
export class dirhamPrice extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DirhamPriceManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set price(v: number) { 
        this._price = getAsNumber(v,true); 
    } public get price(): number { return this._price;} private _price: number;
    public set conversionRate(v: number) { 
        this._conversionRate = getAsNumber(v,true); 
    } public get conversionRate(): number { return this._conversionRate;} private _conversionRate: number;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set canInactive(v: boolean) { this._canInactive = v; } public get canInactive(): boolean { return this._canInactive;} private _canInactive: boolean;
        
    private _typedParent:DirhamPriceManipulationViewModel;

    async inactiveDirhamPrice():Promise<void>{
        if(this.canInactive) {
            let result:string; 
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن قیمت درهم');
            if(result=='yes'){
                this._typedParent.accept(this.id);
            }
        }
    }

    cloneTo(dirham:dirhamPrice){
        dirham.id = this.id;
        dirham.price = this.price;
        dirham.conversionRate = this.conversionRate;
    }

    async edit(){
        this._typedParent.dirhamUpdater(this);
    } 

}

interface IServerUpdater{
    execute(dirhamPrice:dirhamPrice):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'قیمت درهم با موفقیت ثبت شد.';
    }
    async execute(dirhamPrice: dirhamPrice): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateDirhamPrice',{
            ConversionRate:dirhamPrice.conversionRate,
            Price:dirhamPrice.price
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'قیمت درهم با موفقیت بروز شد.';
    }
    async execute(dirhamPrice: dirhamPrice): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/UpdateDirhamPrice',{
            Id: dirhamPrice.id,
            ConversionRate:dirhamPrice.conversionRate,
            Price:dirhamPrice.price
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class dirhamPriceEditor extends dirhamPrice implements IPopup{
    public getTypeId(): string {return 'dirham';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:DirhamPriceManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    verify():string[]{
        let result :string[] =[];
        if(this.price <= 0){
            result.push(' قیمت نامعتبر است.')
        } 
        return result;
    }
  
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت قیمت درهم');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}